import React, {Component} from 'react';
import faq11 from "../../../../../../assets/img/faq11.png";
import {Link} from "react-router-dom";
import '../FaqPages/DeliveryTime.css'
import FocusPageId from "../../FocusPageId";

let i=0;
class DeliveryTime extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }
    constructor(props) {
        super(props);

        this.positionAdject=this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };
    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>納期について</b></h3></li>
                     <div className="brElement"></div> <div className="brElement"></div>
                    <h4  id="a"><b> お届け日を指定することはできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>国際宅急便SGXのため日付・時間の指定を行うことはできません。
                    </p>
                    <p className='all-content-font-size'>
                        <a href="https://www.sgh-globalj.com/index.html">
                            <text className="faq-colored-link">貨物追跡</text></a>
                    </p>
                    <img src={faq11} className="img-begin1"/>

                    {/*<div className='all-content-space'></div>*/}
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4  id="b"><b> 本日中に受付日を確定したいのですが、どうしたらよいですか？</b>
                    </h4>
                    <p className='all-content-font-size'>受付日は、
                    </p>
                    <p className='all-content-font-size'> １．ガーバーファイル承認が完了され
                    </p>
                    <p className='all-content-font-size'> ２．お支払いの完了
                    </p>
                    <p className='all-content-font-size'> をもって確定いたします。
                    </p>
                    <p className='all-content-font-size'> ※速やかにご注文、ガーバーファイルのアップロード、ご入金をお願いします。
                    </p>
                     <div className="brElement"></div>
                    <h4  id="c"><b> 商品はどれくらいで届きますか？</b>
                    </h4>
                    <p className='all-content-font-size'>通常、香港出荷より3 – 5日営業日（配達時間）でお手元に届きます。
                    </p>
                    <p className='all-content-font-size'>
                        <Link to="/delivery">
                            <text className="faq-colored-link">製造時間</text></Link>
                        （基板仕様により異なる） + 配達時間 ＝お客様のお手元に届く日程となります。
                    </p>
                    <p className='all-content-font-size'> ※国際航空輸送でのお届けとなるため、多少前後することを想定して上記営業日の算出をしております。
                    </p>
                    <p className='all-content-font-size'> ※なお、出荷日はマイアカウントページから確認することが可能です。
                    </p>
                    <p className='all-content-font-size'> ※土曜日祝日は出荷日の計算に含まれませんのでご注意ください。
                    </p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/deliverytimeTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeliveryTime;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/DeliveryTime.js